import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { PostLikeGoodsParams } from './types';

/**
 * - 최근 본 상품의 찜하기
 */
export const postLikeGoods = ({
  list_id_referrer,
  list_params_referrer,
  sno,
  folder_sno,
}: PostLikeGoodsParams) => {
  return defaultHttpClient.request<{
    goods_sno: number;
    likes_count: number;
    like: {
      goods_sno: number;
      created_at: string;
      folder_sno: number | null;
    } | null;
    snackbar?: {
      message: string;
      deeplink: string;
    } | null;
  }>({
    method: 'POST',
    url: `/api/v2/goods/${sno}/like`,
    data: {
      list_id_referrer,
      list_params_referrer,
      folder_sno,
    },
  });
};
